module.exports = __webpack_public_path__ + "img/arrow-down.8a9143c4.svg";